export const ATTENDEE_TYPES = {
    PERFORMER: 1,
    CREW: 2,
    GUEST: 3,
    ARTIST_GUEST: 4,
};
